import { BaseError } from './base/base-error';

export class PermissionsConfigError extends BaseError {
  name = 'PermissionsConfigError';
}

